import Vue from 'vue';
import _ from 'lodash';

import { COOKIE_DOMAIN, AUTH_HEADERS } from '@/constants';

/**
 * Store authentication headers to localStorage
 */
export function storeAuthHeaders(response) {
  const headers = _.pick(response.headers, AUTH_HEADERS);
  if (!_.isEmpty(headers)) {
    Vue.cookie.set('authHeaders', JSON.stringify(headers), { domain: COOKIE_DOMAIN });
  }
}

/**
 * Remove authentication headers
 */
export function resetAuthHeaders() {
  Vue.cookie.delete('authHeaders', { domain: COOKIE_DOMAIN });
}

/**
 * Retrieve authentication headers from localStorage
 */
export function getAuthHeaders() {
  return JSON.parse(Vue.cookie.get('authHeaders')) || {};
}



// WEBPACK FOOTER //
// ./src/utils/authentication_headers.js